import React, { useState } from "react";
import { Box, Typography, TextField, Button, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface PixPaymentViewProps {
  encodedImage: string;
  payload: string;
  onBack?: () => void;
}

const PixPaymentView: React.FC<PixPaymentViewProps> = ({ encodedImage, payload, onBack }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(payload);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box sx={{ textAlign: "center", py: 2 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: "var(--ink)" }}>
        Pague com PIX
      </Typography>

      <Box
        sx={{
          my: 2,
          display: "flex",
          justifyContent: "center",
          bgcolor: "#FFFFFF",
          p: 2,
          borderRadius: 2,
          border: "1px solid var(--border)",
        }}
      >
        <img
          src={`data:image/png;base64,${encodedImage}`}
          alt="QR Code PIX"
          style={{ width: 220, height: 220, imageRendering: "pixelated" }}
        />
      </Box>

      <Typography variant="body2" sx={{ color: "var(--ink-soft)",  mb: 1, textAlign: "left" }}>
        Código Copia e Cola:
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        value={payload}
        InputProps={{ readOnly: true, sx: { fontFamily: "monospace", fontSize: "0.75rem" } }}
        sx={{ mb: 2 }}
      />

      <Stack direction="row" spacing={2} justifyContent="center">
        <Button
          variant="contained"
          onClick={handleCopy}
          startIcon={<ContentCopyIcon />}
          sx={{
            bgcolor: copied ? "var(--green)" : "var(--blue)",
            "&:hover": { bgcolor: copied ? "var(--green)" : "var(--blue-hover)", filter: "brightness(0.93)" },
          }}
        >
          {copied ? "Copiado!" : "Copiar Código"}
        </Button>
      </Stack>

      <Stack spacing={1} sx={{ mt: 3, p: 2, bgcolor: "var(--orange-tint)", borderRadius: 2, border: "1px solid var(--orange)" }}>
        <Typography variant="body2" sx={{ color: "var(--ink-soft)" }}>
          ⏳ Após realizar o pagamento, sua assinatura será ativada automaticamente.
        </Typography>
        <Typography variant="body2" sx={{ color: "var(--ink-soft)" }}>
          O sistema verificará o status e redirecionará você para o painel assim que for confirmado.
        </Typography>
      </Stack>

      {onBack && (
        <Button
          variant="outlined"
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
          sx={{
            mt: 3,
            color: "var(--ink-soft)",
            borderColor: "var(--border-strong)",
            textTransform: "none",
            "&:hover": { borderColor: "var(--ink-faint)", bgcolor: "var(--surface-2)" },
          }}
        >
          Voltar / Alterar Forma de Pagamento
        </Button>
      )}
    </Box>
  );
};

export default PixPaymentView;
